import { ICountryStrategy, ICountryStrategyFactory } from "../interfaces/countryStrategy";
import { argentinaStrategy } from "./countries/argentinaStrategy";
import { colombiaStrategy } from "./countries/colombiaStrategy";
import { DEFAULT_COUNTRY } from "../utils/constants";
import { panamaStrategy } from "./countries/panamaStrategy";

class CountryStrategyFactory implements ICountryStrategyFactory {
  private strategies: Map<string, ICountryStrategy> = new Map();

  constructor() {
    this.registerStrategy(argentinaStrategy);
    this.registerStrategy(colombiaStrategy);
    this.registerStrategy(panamaStrategy);
  }

  getStrategy(countryCode: string): ICountryStrategy {
    const strategy = this.strategies.get(countryCode);
    if (!strategy) {
      const fallback = this.strategies.get(DEFAULT_COUNTRY);
      if (!fallback) {
        throw new Error(`No strategy found for country: ${countryCode}`);
      }
      return fallback;
    }
    return strategy;
  }

  getAllStrategies(): ICountryStrategy[] {
    return Array.from(this.strategies.values());
  }

  registerStrategy(strategy: ICountryStrategy): void {
    this.strategies.set(strategy.code, strategy);
  }
}

export const countryStrategyFactory = new CountryStrategyFactory();
